function formResize(size) {
  const popups = document.querySelectorAll(".ac-popup");
  popups.forEach((popup) => {
    if (size === "lg") {
      popup.classList.add("ac-popup--lg");
      popup.classList.remove("ac-popup--sm");
    } else if (size === "sm") {
      popup.classList.add("ac-popup--sm");
      popup.classList.remove("ac-popup--lg");
    } else {
      popup.classList.add("ac-popup--md");
      popup.classList.remove("ac-popup--lg");
      popup.classList.remove("ac-popup--sm");
    }
  });
}
function showSpinner() {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = "block";
  }
}

function hideSpinner() {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = "none";
  }
}

function toggleSpinner(show) {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = show ? "block" : "none";
  }
}

function initializeDropdown(dropdownElement) {
  const dropdownToggleBtns = dropdownElement.querySelectorAll(
    "[data-dropdown-toggle]"
  );
  dropdownToggleBtns.forEach((dropdownToggle) => {
    const dropdownMenu = document.querySelector(
      `[data-dropdown-menu="${dropdownToggle.dataset.dropdownToggle}"]`
    );
    const closeButton = dropdownMenu.querySelector("[data-dropdown-close]");

    dropdownToggle.addEventListener("click", () => {
      dropdownMenu.classList.toggle("active");
    });

    closeButton.addEventListener("click", () => {
      dropdownMenu.classList.remove("active");
    });
  });
}

  const closePopups = document.querySelectorAll('[data-close-popup-btn]');
  closePopups.forEach(element => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      closePopup();
    });
  });

  function closePopup() {
    const elementsToRemove = document.querySelectorAll('.tingle-modal.tingle-modal--visible');
    elementsToRemove.forEach(element => {
      element.classList.remove('tingle-modal--visible');
      // close popup fix start
      if (document.body.classList.contains('tingle-enabled')) {
            document.body.classList.remove('tingle-enabled');
      }
      if (document.documentElement.classList.contains('tingle-enabled')) {
          document.documentElement.classList.remove('tingle-enabled');
      }
      // close popup fix end
    })
  }

  let googleMapsAPIPromise = null; // Cache promise for Google Maps API

  function loadGoogleMapsAPI(callback) {
    // If API is already loaded
    if (typeof google === 'object' && typeof google.maps === 'object') {
      if (callback) callback();
      return Promise.resolve();
    }

    // If loading is already in progress, wait for result
    if (googleMapsAPIPromise) {
      return googleMapsAPIPromise.then(() => {
        if (callback) callback();
      });
    }
  
    // Create new promise for loading
    googleMapsAPIPromise = new Promise((resolve) => {
      window.googleMapsAPILoaded = function () {
        if (callback) callback();
        resolve();
      };

      // Load API script
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${window.googleMapsApiKey}&libraries=places&loading=async&callback=googleMapsAPILoaded`;
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        // If loading error - reject promise
        googleMapsAPIPromise = null;
        resolve(); // But continue work to not stop the page
      };
      document.head.appendChild(script);
    });

    return googleMapsAPIPromise;
  }
  
  function initAutocomplete() {
    loadGoogleMapsAPI(function () {
      initializeAutocompleteForForms();
    });
  }
  window.initAutocomplete = initAutocomplete;
  async function initializeAutocompleteForForms() {
    const forms = document.querySelectorAll('[data-account-block="registration"], [data-account-block="salon"], [data-account-block="shipping"]');

    for (const form of forms) {
      // Function to initialize autocomplete for one form
      const initFormAutocomplete = async (suffix = '') => {
        const address1Field = form.querySelector(`[data-address1-field${suffix}]`);
        if (!address1Field) return;

        // Skip if autocomplete was already initialized for this field
        if (address1Field.getAttribute('data-autocomplete-id')) return;

        const fieldSuffix = (id) => form.querySelector(`[data-${id}${suffix}]`);

        const fields = {
          address1Field: fieldSuffix('address1-field'),
          address2Field: fieldSuffix('address2-field'),
          cityField: fieldSuffix('city-field'),
          stateField: fieldSuffix('state-field'),
          zipField: fieldSuffix('zip-field'),
          countryField: fieldSuffix('country-field')
        };

        const storeId = window.proStoreId || 'US';
        const countryRestriction = storeId === 'CA' ? 'CA' : 'US';

        try {
          await setupAutocomplete({
            ...fields,
            countryRestriction: countryRestriction
          });
        } catch (error) {
          // Autocomplete initialization is optional
        }
      };

      // Initialize main form and shipping form
      await initFormAutocomplete('');
      await initFormAutocomplete('-shipping');
    }
  }
  async function setupAutocomplete(config) {
    const {
      address1Field,
      address2Field,
      cityField,
      stateField,
      zipField,
      countryField,
      countryRestriction,
    } = config;

    const uniqueId = 'autocomplete-' + Math.random().toString(36).substr(2, 9);
    address1Field.setAttribute('data-autocomplete-id', uniqueId);

    // Use the new PlaceAutocompleteElement API.
    // includedPrimaryTypes: ['street_address'] mirrors the legacy
    // `types: ['address']` filter — predictions are restricted to street
    // addresses, so cities/businesses (e.g. "100 Mile House") aren't offered
    // and selecting one can't blank out the field.
    const autocompleteEl = new google.maps.places.PlaceAutocompleteElement({
      includedRegionCodes: [countryRestriction.toLowerCase()],
      includedPrimaryTypes: ['street_address'],
    });
    autocompleteEl.setAttribute('data-autocomplete-id', uniqueId);

    // Copy placeholder from original input
    if (address1Field.placeholder) {
      autocompleteEl.placeholder = address1Field.placeholder;
    }

    // Prevent Enter key inside autocomplete from submitting the parent form
    autocompleteEl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') e.preventDefault();
    });

    // Insert autocomplete element and hide original input
    address1Field.parentNode.insertBefore(autocompleteEl, address1Field);
    address1Field.type = 'hidden';

    // If the field is pre-populated (e.g. from localStorage/HubSpot), show the value
    if (address1Field.value) {
      autocompleteEl.value = address1Field.value;
    }

    // Intercept programmatic .value changes on the hidden input so the visible
    // autocomplete element stays in sync (e.g. when account-scripts hydrates the form)
    const valueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(address1Field, 'value', {
      set(val) {
        valueDescriptor.set.call(this, val);
        if (autocompleteEl.value !== val) autocompleteEl.value = val || '';
      },
      get() {
        return valueDescriptor.get.call(this);
      }
    });

    // Sync manual typing from autocomplete element back to hidden input
    autocompleteEl.addEventListener('input', () => {
      valueDescriptor.set.call(address1Field, autocompleteEl.value || '');
      address1Field.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // When the field is pre-populated (programmatic .value set treats the value
    // as a confirmed selection — predictions don't fire on edit until the user
    // changes the text). On focus, refresh predictions and select the existing
    // text so the next keystroke replaces it.
    autocompleteEl.addEventListener('focusin', () => {
      if (!autocompleteEl.value) return;

      // Try to reach the inner input. PlaceAutocompleteElement exposes it via
      // a `gmp-place-autocomplete-input` part or as a slotted input.
      const innerInput =
        autocompleteEl.querySelector('input') ||
        (autocompleteEl.shadowRoot && autocompleteEl.shadowRoot.querySelector('input'));

      if (innerInput) {
        innerInput.select();
        innerInput.dispatchEvent(new InputEvent('input', {
          data: innerInput.value,
          bubbles: true,
        }));
      } else {
        // Fallback: dispatch on the host element. Some builds bubble it down.
        autocompleteEl.dispatchEvent(new InputEvent('input', {
          data: autocompleteEl.value,
          bubbles: true,
        }));
      }
    });

    // Handle place selection via new gmp-select event
    autocompleteEl.addEventListener('gmp-select', async ({ placePrediction }) => {
      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents'] });
      fillInAddress(place, {
        address1Field,
        address2Field,
        cityField,
        stateField,
        zipField,
        countryField,
      }, uniqueId, autocompleteEl);
    });
  }

  function fillInAddress(place, fields, uniqueId, autocompleteEl) {
    let address1 = "";
    let postcode = "";

    // New API uses addressComponents with longText/shortText instead of long_name/short_name
    for (const component of place.addressComponents) {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number":
          address1 = `${component.longText} ${address1}`;
          break;
        case "route":
          address1 += component.shortText;
          break;
        case "postal_code":
          postcode = `${component.longText}${postcode}`;
          break;
        case "postal_code_suffix":
          postcode = `${postcode}-${component.longText}`;
          break;
        case "locality":
          if (fields.cityField) {
            fields.cityField.value = component.longText;
          }
          break;
        case "administrative_area_level_1":
          if (fields.stateField) {
            selectOptionInDropdown(fields.stateField, component.shortText);
          }
          break;
      }
    }
    // Defensive guard: a non-address selection (e.g. a city like "100 Mile
    // House") has no street_number/route components, so address1 is "".
    // Don't blank the field in that case — keep what the user already had.
    if (address1) {
      fields.address1Field.value = address1;
      if (autocompleteEl) autocompleteEl.value = address1;
    } else {
      console.warn('[autocomplete] selected place has no street address — skipping address1 overwrite', place);
    }

    // Format and validate the postal code. Google sometimes returns only a
    // CA Forward Sortation Area (e.g. "M5A") instead of a full postal code —
    // those would fail downstream validation, so skip writing them.
    if (fields.zipField && postcode) {
      const formatted = window.formatPostalCode ? window.formatPostalCode(postcode) : postcode;
      const isFullUSZip   = /^\d{5}(-\d{4})?$/.test(formatted);
      const isFullCAZip   = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i.test(formatted);
      if (isFullUSZip || isFullCAZip) {
        fields.zipField.value = formatted;
        if (window.markZipAsAutocompleteFilled) window.markZipAsAutocompleteFilled(fields.zipField.id);
      } else {
        console.warn('[autocomplete] postal code is incomplete, skipping:', formatted);
      }
    }

    // Clear validation errors for filled fields
    const clearFieldError = (field) => {
      if (!field) return;
      field.classList.remove('invalid');
      const errorElement = field.nextElementSibling;
      if (errorElement && errorElement.classList.contains('ac-text--error')) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
      }
    };

    clearFieldError(fields.address1Field);
    clearFieldError(fields.cityField);
    clearFieldError(fields.stateField);
    clearFieldError(fields.zipField);

    // Trigger input AND change events for address1Field so trackFormChanges() detects it
    // and form validation runs to enable the Save button
    if (fields.address1Field) {
      fields.address1Field.dispatchEvent(new Event('input', { bubbles: true }));
      fields.address1Field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (fields.address2Field) fields.address2Field.dispatchEvent(new Event('input'));
    if (fields.cityField) {
      fields.cityField.dispatchEvent(new Event('input'));
      fields.cityField.dispatchEvent(new Event('change'));
    }
    if (fields.stateField) fields.stateField.dispatchEvent(new Event('change'));
    if (fields.zipField) {
      fields.zipField.dispatchEvent(new Event('input'));
      fields.zipField.dispatchEvent(new Event('change'));
    }

    // Move focus to the second address line immediately
    if (fields.address2Field) {
      fields.address2Field.focus();
    }
  }
  
  function selectOptionInDropdown(selectElement, value) {
    if (!selectElement || !value) return;

    const upperValue = value.toUpperCase();

    // Optimization: if value is already selected, don't process
    if (selectElement.value.toUpperCase() === upperValue) return;

    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].value.toUpperCase() === upperValue) {
        selectElement.selectedIndex = i;
        break;
      }
    }
  }
  function isRegistrationPage() {
    // Check if the URL hash is '#register' or the pathname includes '/register'
    return window.location.hash === '#register' || window.location.pathname.includes('/register');
  }
  function attachPasswordHider(){
    document.addEventListener('click', function(e) {
      if(e.target.classList.contains('toggle-password-icon')){
        let passwordInput = e.target.parentNode.querySelector(".toggle-password-visibility");
        let togglePassword = e.target;
        let closedEyeSrc = togglePassword.getAttribute('data-closed-eye');
        let openedEyeSrc = togglePassword.getAttribute('data-opened-eye');
        let isPasswordVisible = passwordInput.getAttribute('type') === 'text';
        passwordInput.setAttribute('type', isPasswordVisible ? 'password' : 'text');
        e.target.src = isPasswordVisible ?  closedEyeSrc : openedEyeSrc;
      }
    });
  }

  function showToast(title, message, duration, className = '') {
    // Create toast element
    const toast = document.createElement('div');
    toast.classList.add('toast');

      if (className) {
          toast.classList.add(className);
      }

    // Add content
    toast.innerHTML = `
      <div>
        <strong>${title}</strong>
        <div>${message}</div>
      </div>
      <button class="close-btn">&times;</button>
    `;

    // Append to the container
    let container = document.querySelector('.toast-container');
    if (!container) {
      container = document.createElement('div');
      container.classList.add('toast-container');
      document.body.appendChild(container);
    }
    container.appendChild(toast);
    if(!!duration){
      setTimeout(() => {
        toast.style.animation = 'fadeOut 0.5s forwards';
        toast.addEventListener('animationend', () => toast.remove());
      }, duration);
    }
    // Remove toast after specified duration

    // Add close button functionality
    toast.querySelector('.close-btn').addEventListener('click', () => {
      toast.style.animation = 'fadeOut 0.5s forwards';
      toast.addEventListener('animationend', () => toast.remove());
    });
  }


  // Clean up stale autocomplete elements in a container and re-initialize.
  // Used after tingle modal copies HTML via setContent() — the cloned
  // PlaceAutocompleteElements lose their event listeners and need to be rebuilt.
  window.reinitAutocompleteInModal = function() {
    const modal = document.querySelector('.tingle-modal-box__content');
    if (!modal) return;

    // Remove non-functional cloned PlaceAutocompleteElements
    modal.querySelectorAll('gmp-place-autocomplete').forEach(el => el.remove());

    // Restore address1 inputs that were hidden by previous init
    modal.querySelectorAll('[data-autocomplete-id]').forEach(el => {
      el.removeAttribute('data-autocomplete-id');
      if (el.type === 'hidden' && el.hasAttribute('data-address1-field')) {
        el.type = 'text';
      }
      // Also handle shipping suffix variant
      if (el.type === 'hidden' && el.hasAttribute('data-address1-field-shipping')) {
        el.type = 'text';
      }
    });

    initAutocomplete();
  };

  // Initialize Autocomplete on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    var hasAddressForms = document.querySelector(
      '[data-account-block="registration"], [data-account-block="salon"], [data-account-block="shipping"]'
    );
    if (hasAddressForms) {
      initAutocomplete();
    }
    attachPasswordHider();
  });

window.translations = window.translations || {
    iwish: {
      en: {
        addFavorite: "added to wishlist",
        removeFavorite: "removed from wishlist",
      },
      fr: {
        addFavorite: "ajouté à la liste de souhaits",
        removeFavorite: "retiré de la liste de souhaits",
      },
    },
    common: {
      en: {
        save: "Save",
        cancel: "Cancel",
      },
      fr: {
        save: "Enregistrer",
        cancel: "Annuler",
      },
    },
    fogotPassword: {
        en: {
            emptyField: "please enter a valid email address",
        },
        fr: {
          emptyField: "veuillez entrer une adresse e-mail valide",
        },
    },
    sideCart: {
      en: {
        title: "your rewards order",
        emptyCart: "your cart is empty",
        browseProduct: "browse products",
        freeshipWaySub: "you're",
        freeshipWay: "away from qualifying for free shipping",
        freeText: "you've earned free shipping",
        freeShipping: "salon merch items do not qualify for free shipping",
        finalSale: "**final sale**",
        notQualified: "does not qualify for free shipping",
        free: "free",
        maxError: "you can add only",
        maxErrorSup: "sample",
        orderTotal: "order total",
        submitOrder: "SUBMIT ORDER",
        rewardsOrder: "rewards orders are limited to one per month"
      },
      fr: {
        title: "votre commande de récompenses",
        emptyCart: "votre panier est vide",
        browseProduct: "parcourir les produits",
        freeshipWaySub: "vous êtes",
        freeshipWay: "à quelques pas de la qualification pour la livraison gratuite",
        freeText: "vous avez gagné la livraison gratuite",
        freeShipping: "les articles de merchandising de salon ne sont pas éligibles à la livraison gratuite",
        finalSale: "**solde final**",
        notQualified: "n’est pas éligible à la livraison gratuite",
        free: "gratuit",
        maxError: "vous pouvez ajouter seulement",
        maxErrorSup: "échantillon",
        orderTotal: "total de la commande",
        submitOrder: "SOUMETTRE LA COMMANDE",
        rewardsOrder: "les commandes de récompenses sont limitées à une par mois"
      }
    },
  };

function getErrorMessage(key) {
  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
  const errorMessage = errorMessages.errors[selectedLanguage][key];
  return errorMessage || key;
}

// Text for a backend error object ({ code, message }). Never returns the bare code.
function getBackendErrorMessage(error) {
  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
  const messages = (window.errorMessages && window.errorMessages.errors && window.errorMessages.errors[selectedLanguage]) || {};
  const own = (key) => (typeof key === 'string' && Object.prototype.hasOwnProperty.call(messages, key) && typeof messages[key] === 'string') ? messages[key] : '';
  return own(error && error.code) || own('invalid_data_format') || (error && typeof error.message === 'string' ? error.message : '');
}

// Get hubspot infor from cache

function getPointsCache(customerId) {
  const cacheKey = `customerHubspotProfile_${customerId}`;
  const cachedData = JSON.parse(localStorage.getItem(cacheKey) || '{}');
  const properties = cachedData?.response?.properties;
      if (properties) {
          // Return only the main points value (do not include preselected_reward_points)
          return Number(properties.points || 0);
      }

  return null;
}

function waitForPoints(customerId, timeout = 2000, interval = 100) {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const check = () => {
      const totalPoints = getPointsCache(customerId);
      if (typeof totalPoints === 'number' && !isNaN(totalPoints)) {
        resolve(totalPoints);
      } else if (Date.now() - startTime >= timeout) {
        resolve(0); // fallback
      } else {
        setTimeout(check, interval);
      }
    };
    check();
  });
}

// ============================================
// NORMALIZATION HELPERS (FIELD_NORMALIZATION_QA)
// ============================================

// Basic normalization: lowercase (for emails)
function normalizeToLowerCase(value) {
    return value ? value.trim().toLowerCase() : '';
}

// Basic normalization: Capitalize Each Word (for names, addresses, cities)
function normalizeToCapitalize(value) {
    if (!value) return '';
    return value
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

// Basic normalization: UPPERCASE (for postal codes, short province codes)
function normalizeToUpperCase(value) {
    return value ? value.trim().toUpperCase() : '';
}

// Specialized: format Canadian postal code to 'K1A 0B1' format
function formatCanadianZipCode(zip) {
    if (!zip) return '';
    const s = String(zip).toUpperCase().replace(/\s+/g, '');
    const noSpacePattern = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;
    if (noSpacePattern.test(s)) {
        return s.slice(0, 3) + ' ' + s.slice(3);
    }
    return String(zip).toUpperCase();
}

// Specialized: validate postal/zip code for US and Canada
function validateZipCode(postalCode, country) {
    if (!postalCode) return false;
    const s = String(postalCode).trim();
    const countryNorm = (country || '').toString().trim().toLowerCase();
    const postalPatternUSA = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    const postalPatternCanada = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

    if (countryNorm === 'canada' || countryNorm === 'ca') {
        return postalPatternCanada.test(s.toUpperCase());
    }
    return postalPatternUSA.test(s);
}

// Specialized: normalize province/state (UPPERCASE for 2-char codes, Capitalize for full names)
function normalizeProvinceState(value) {
    if (!value) return '';
    const trimmed = String(value).trim();
    if (trimmed.length === 2) return normalizeToUpperCase(trimmed);
    return normalizeToCapitalize(trimmed);
}

// Specialized: normalize country for account forms (returns code: US/CA)
function normalizeCountryForAccount(value) {
    if (!value) return '';
    const trimmed = String(value).trim();
    const lc = trimmed.toLowerCase();
    if (trimmed.length === 2) return normalizeToUpperCase(trimmed);
    if (lc === 'united states' || lc === 'usa') return 'US';
    if (lc === 'canada') return 'CA';
    return trimmed;
}

// ============================================
// END NORMALIZATION HELPERS
// ============================================

/*
==== GOOGLE MAPS AUTOCOMPLETE OPTIMIZATIONS ====

1. API LOADING:
   - Promise is cached to prevent repeated loading
   - Error handling with graceful fallback
   - Lazy loading - API loads only when needed

2. DOM MANIPULATION:
   - Efficient PAC container selection without looping through all
   - Minimal number of DOM queries
   - Selector caching

3. AUTOCOMPLETE LOGIC:
   - Less code for initializeAutocompleteForForms
   - Dynamic field selection with suffixes
   - Error handling at warning level (not critical)

4. DROPDOWN SELECTION:
   - Early exit if value is already selected
   - Parameter validation before use
   - Efficient option selection

5. CODE:
   - Removed debug console.log
   - Removed function duplications
   - Clean, readable code without unnecessary operations
*/
